import React from 'react'

function PantherWheel() {
  return (
    <div>PantherWheel</div>
  )
}

export default PantherWheel